import {Transition} from '@mantine/core';
import classNames from 'classnames';
import type React from 'react';
import {useEffect, useState} from 'react';
import {MdList} from 'react-icons/md';
import {useIsAppWebView} from '../../../../../shared/hooks/useIsAppWebView';

type Props = {
  openModal: () => void;
};

export const SpFloatContent: React.FC<Props> = ({openModal}) => {
  const [mounted, setMounted] = useState(false);
  const isWebView = useIsAppWebView();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 440) {
        // スクロール位置を調整
        setMounted(true);
      } else {
        setMounted(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <Transition
      mounted={mounted}
      transition="scale-x"
      duration={600}
      timingFunction="ease"
    >
      {(styles) => (
        <div
          className={classNames(
            'text-base font-bold flex items-center bg-white w-[80px] rounded-r-16 shadow-modal p-8 sticky z-40 pc:hidden',
            {
              'top-[74px]': !isWebView,
              'top-[8px]': isWebView,
            },
          )}
          onClick={openModal}
          style={styles}
        >
          <div className="flex h-20 text-primary-1">
            <MdList size={20} /> <span>目次</span>
          </div>
        </div>
      )}
    </Transition>
  );
};
